import base from './base';
import {dateToHTML} from '@netx/core/utils';

type Value = number | string | Array<number | string>;

export const date = (value?: Value) => {
	value = base(value);
	if (value == null) return value;
	if (Array.isArray(value)) {
		value = value.map((v) => {
			if (v.toString().includes('/') || Number.isInteger(v)) v = dateToHTML(v);
			return v;
		});
	} else if (Number.isInteger(value) || value.toString().includes('/')) {
		value = dateToHTML(value);
	}

	return value;
};

export default date;
